<div class="warrper-toast">
    <span class="icon">
        <img class="success"
        src="../../../../../assets/images/success.png" 
        alt="success" />
    </span>
    <span class="text font-bold" [innerHTML]="toastData.text"></span>
    <span class="icon-close" (click)="dismiss()">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.44609 12.4721L0.527344 11.5533L5.58047 6.5002L0.527344 1.44707L1.44609 0.52832L6.49922 5.58144L11.5523 0.52832L12.4711 1.44707L7.41797 6.5002L12.4711 11.5533L11.5523 12.4721L6.49922 7.41895L1.44609 12.4721Z" fill="#ACACAC"/>
        </svg>
    </span>
</div>